import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageArLite() {
    return (
<div className="privacy-policy-container">
<h1>سياسة الخصوصية لتطبيق تسبيح ذكر لايت</h1>
      <p>آخر تحديث: 31 يناير 2024</p>

      <h2>مقدمة</h2>
      <p>مرحبًا بكم في تطبيق تسبيح ذكر لايت. تهدف هذه السياسة إلى إعلامكم بكيفية التعامل مع بياناتكم عند استخدام التطبيق. الجمع الوحيد للبيانات في هذا التطبيق يتم عن طريق AdMob، وهي خدمة إعلانات من Google، ونحن لا نجمع بيانات شخصية بشكل نشط.</p>

      <h2>1. جمع واستخدام بياناتك الشخصية</h2>
      <h3>أ. أنواع البيانات المجمعة</h3>
      <h4>ط. استخدام البيانات من خلال AdMob</h4>
      <p>يستخدم تطبيقنا AdMob لعرض الإعلانات. يمكن لـ AdMob جمع بيانات مثل عنوان IP الخاص بك، معرف جهازك، ومعلومات حول استخدامك للتطبيق. يتم استخدام هذه التفاصيل لتوفير وتحسين تجربة الإعلان.</p>

      <h3>ب. استخدام البيانات</h3>
      <p>البيانات التي يتم جمعها من قبل AdMob تستخدم لـ:</p>
      <ul>
        <li>توفير وتخصيص الإعلانات داخل التطبيق.</li>
        <li>تحليل فعالية الإعلانات المعروضة.</li>
      </ul>

      <h3>ج. التحكم من قبل المستخدم</h3>
      <p>يمكنك التحكم في استخدام بياناتك للإعلانات المخصصة من خلال إعدادات جهازك.</p>

      <h2>2. نقل البيانات</h2>
      <p>قد يتم نقل معلوماتك وصيانتها على أجهزة الكمبيوتر التي تقع خارج دولتك أو مقاطعتك أو بلدك حيث قد تختلف قوانين حماية البيانات.</p>

      <h2>3. الكشف عن بياناتك الشخصية</h2>
      <p>قد يتم مشاركة البيانات التي يتم جمعها بواسطة AdMob وفقًا لسياسة خصوصية Google والمتطلبات القانونية.</p>

      <h2>4. أمان بياناتك الشخصية</h2>
      <p>أمان بياناتك مهم لنا. ومع ذلك، لا توجد طريقة للنقل عبر الإنترنت أو طريقة للتخزين الإلكتروني آمنة بنسبة 100%.</p>

      <h2>5. الروابط إلى مواقع أخرى</h2>
      <p>قد يحتوي خدمتنا على روابط إلى مواقع أخرى. إذا نقرت على رابط لطرف ثالث، ستتم إعادة توجيهك إلى موقع ذلك الطرف الثالث.</p>

      <h2>6. تغييرات على هذه السياسة</h2>
      <p>قد نحدث سياسة الخصوصية هذه من وقت لآخر. سنقوم بإعلامك بأي تغييرات من خلال نشر السياسة الجديدة على هذه الصفحة.</p>

      <h2>7. اتصل بنا</h2>
      <p>إذا كان لديك أي أسئلة حول هذه السياسة، يرجى الاتصال بنا.</p>

      <h2>روابط مفيدة</h2>
      <p><a href="https://policies.google.com/privacy">سياسة خصوصية Google</a></p>
    </div>

    );
}

export default PrivacyPolicyPageArLite;
